import { useEffect, useState } from 'react';

import { useRecoilValue } from 'recoil';

import ProjectPageContainer from 'src/components/ProjectPageContainer';
import { projectState } from 'src/states/project';
import { Modality } from 'src/types/api/data/image';
import { JobsStatsState } from 'src/types/client/stats';

import AnnotatorsTab from './ManageProject/AnnotatorsTab';

function ProjectAnnotatorsContent({
  modalityLabel,
  projectId,
}: {
  modalityLabel: Modality;
  projectId: string;
}): JSX.Element {
  const [jobStatsState, setJobStatsState] =
    useState<JobsStatsState>('hasOngoingJobs');

  const project = useRecoilValue(
    projectState.project({ projectId, modality: modalityLabel })
  );

  useEffect(() => {
    const { total, completedStage, createdStage } = project.jobStats.annotation;
    if (createdStage === 0) setJobStatsState('noJobLeft');
    else setJobStatsState('hasOngoingJobs');
    if (total > 0 && total === completedStage) setJobStatsState('allJobsDone');
  }, [project.jobStats.annotation]);

  return (
    <AnnotatorsTab
      projectId={projectId}
      modality={modalityLabel}
      jobStatsState={jobStatsState}
      annotators={project.annotators}
    />
  );
}

export default function ProjectAnnotators(): JSX.Element {
  return (
    <ProjectPageContainer>
      {(projectId, modalityLabel) => (
        <ProjectAnnotatorsContent
          modalityLabel={modalityLabel}
          projectId={projectId}
        />
      )}
    </ProjectPageContainer>
  );
}
